module.exports = __webpack_public_path__ + "img/rosebear.1d13f254.png";